import React, { Component } from 'react';
import { Row, Form, FormGroup, FormControl, ControlLabel, Col, Button } from 'react-bootstrap';
import { getYearOptions } from '../../../services/dateServices';
import Api from '../../../../../Global/Modules/Api'
import { Link } from 'react-router-dom';
const FETCH_URL = "api/educations/publicationadmin"

class Publicatie extends Component {

    constructor() {
        super();
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this)
        this.state = {
            data: {
                institution: '',
                description: '',
                articleName: '',
                yearEnd: '',
                pages: 0
            },
            errors: {}
        }
    }
    handleChange(event) {
        const target = event.target
        const name = target.name
        const value = target.value
        this.setState({ data: { ...this.state.data, [name]: value } })
    }
    // Function that will be executed when the submit button is pressed
    handleSubmit(event) {
        event.preventDefault()
        var formData = new FormData()

        Object.keys(this.state.data).forEach(e => {
            formData.append(e, this.state.data[e])
        })
        formData.append('MemberId', this.props.id)
        const file = this.fileInput.files[0]
        formData.append('file', file === undefined ? null : file)


        // TODO: Post payload to the API
        Api.PostApiWithFile(FETCH_URL, formData, this.props.history)
            .then(data => {
                alert('Publicatie saved')
                window.location.href = '/admin/leden/lid/kennis/' + this.props.id

            })

    }

    render() {
        let errors = this.state.errors
        return (
            <Form horizontal onSubmit={this.handleSubmit}>
                <FormGroup controlId="PublicatieVakbladEnTypeArtikel">
                    <Col componentClass={ControlLabel} sm={4}>
                        Vakblad en type artikel
                    </Col>

                    <Col sm={6}>
                        <FormControl name="institution" componentClass="select" value={this.state.data.institution} onChange={this.handleChange} required>
                            <option value="">selecteer</option>
                            <option value="Cement: technisch">Cement: technisch</option>
                            <option value="Cement: algemeen">Cement: algemeen</option>
                            <option value="Bouwen met Staal: technisch">Bouwen met Staal: technisch</option>
                            <option value="Bouwen met Staal: algemeen">Bouwen met Staal: algemeen</option>
                            <option value="Overig">overig</option>
                        </FormControl>
                        {Api.showError(errors, "institution")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="PublicatieNaamVakbladIndienOverig">
                    <Col componentClass={ControlLabel} sm={4}>
                        Naam vakblad indien overig
                    </Col>
                    <Col sm={6}>
                        <FormControl name="description" maxLength="50" type="text" required value={this.state.data.description} onChange={this.handleChange} />
                    </Col>
                </FormGroup>

                <FormGroup controlId="PublicatieNaamArtikel">
                    <Col componentClass={ControlLabel} sm={4}>
                        Naam artikel
                    </Col>
                    <Col sm={6}>
                        <FormControl name="articleName" type="text" value={this.state.data.articleName} onChange={this.handleChange} required />
                        {Api.showError(errors, "articleName")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="PublicatieJaar">
                    <Col componentClass={ControlLabel} sm={4}>
                        Jaar
                    </Col>

                    <Col sm={6}>
                        <FormControl name="yearEnd" componentClass="select" value={this.state.data.yearEnd} onChange={this.handleChange} required>
                            <option value="">selecteer</option>
                            {getYearOptions()}
                        </FormControl>
                        {Api.showError(errors, "yearEnd")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="PublicatieUpload">
                    <Col componentClass={ControlLabel} sm={4}>
                        Upload
                    </Col>
                    <Col sm={6}>
                        <FormControl type="File" inputRef={input => this.fileInput = input} required />
                        {Api.showError(errors, "file")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="PublicatiePaginas">
                    <Col componentClass={ControlLabel} sm={4}>
                        Aantal pagina's
                    </Col>
                    <Col sm={6}>
                        <FormControl name="pages" type="number" value={this.state.data.pages} onChange={this.handleChange} required />

                    </Col>
                </FormGroup>
                <FormGroup>
                    <Col sm={2}>
                        <Link to={'/admin/leden/lid/kennis/' + this.props.id} className="btn btn-default">Terug</Link>
                    </Col>
                    <Col smOffset={8} sm={2}>
                        <Button type="submit">Voeg Toe</Button>
                    </Col>
                </FormGroup>
            </Form>
        );
    }
}

export default Publicatie;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Leden/Lid/Toevoegen/Publicatie.js